export default __webpack_public_path__ + "static/media/wizard.2e0d6ab4.mov";